import { mapGetters } from 'vuex';

// eslint-disable-next-line
export const authComputed = {
  ...mapGetters('account', ['loggedIn']),
};
